import { reconcileMoney } from '../../../src/receipts/money.js';

const MONEY_MISMATCH =
  'Net + VAT does not match gross — apply a suggested split, or tick that you have checked the receipt and accept these figures';

const CURRENCY_UNREAD =
  'Currency was not read from the receipt — pick it before confirming. It is never assumed GBP';

/** Reasons Confirm must not proceed. Never silent — caller shows every string. */
export function confirmBlockers(fields: {
  supplier_name: string | null;
  receipt_date: string | null;
  category: string | null;
  currency?: string | null;
  gross_pence: number | null;
  net_pence?: number | null;
  vat_pence?: number | null;
  money_reconcile_overridden?: boolean;
}): string[] {
  const missing: string[] = [];
  if (!fields.supplier_name?.trim()) {
    missing.push('Supplier required before confirming');
  }
  if (!fields.receipt_date?.trim()) {
    missing.push('Date required before confirming');
  }
  if (!fields.category?.trim()) {
    missing.push('Category required before confirming');
  }
  if (!fields.currency?.trim()) {
    missing.push(CURRENCY_UNREAD);
  }
  if (fields.gross_pence == null) {
    missing.push('Gross amount required before confirming');
  }
  const money = reconcileMoney({
    net_pence: fields.net_pence ?? null,
    vat_pence: fields.vat_pence ?? null,
    gross_pence: fields.gross_pence,
  });
  if (!money.ok && !fields.money_reconcile_overridden) {
    missing.push(MONEY_MISMATCH);
  }
  return missing;
}
